import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import GroupFormFields from "./GroupFormFields.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.grupos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Grupo"}
                buttonTitle={"Ver Grupo"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <GroupFormFields disabled={true} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/Detail.js